// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/*
* vue:
* app:
* router:路由文件
* store：状态管理文件
* */
// vue和element的js使用cdn引入了 所以不用再次引入
/*
* 注意，原本的element-ui的版本是2.4.11，后来css更新到了2.8.2，目前js还是2.4.11
* */

import App from './App'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import { checkPower } from '@/utils/checkPower'
// import Vue from 'vue'
// import ELEMENT from 'element-ui'

Vue.config.productionTip = false
Vue.use(ELEMENT)
Vue.use(store)

// 若是没有开启Devtools工具，在开发环境中开启，在生产环境中关闭
if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true
} else {
  Vue.config.devtools = false
}
// 权限
Vue.directive('power', {
  inserted (el, binding) {
    if (!checkPower(binding.value)) {
      el.style.display = 'none'
    }
  }
})
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js